/**
 * Функционал таймера обратного отсчёта для секции start__marque
 */
document.addEventListener('DOMContentLoaded', () => {
   
    // Инициализация таймера
    initCountdown();
    
    // Запуск обновления каждую секунду
    setInterval(updateCountdown, 1000);
});

/**
 * Инициализация таймера
 */
function initCountdown(): void {
    updateCountdown();
}

/**
 * Обновление таймера обратного отсчёта
 */
function updateCountdown(): void {
    const timerElement = document.querySelector('.start__marque__timer');
    if (!timerElement) return;
    
    // Получаем текущее время
    const now = new Date();
    
    // Создаем дату для конца текущего дня (23:59:59)
    const endOfDay = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        23, 59, 59
    );
    
    // Если текущее время больше конца дня, используем конец следующего дня
    if (now.getTime() > endOfDay.getTime()) {
        endOfDay.setDate(endOfDay.getDate() + 1);
    }
    
    // Вычисляем разницу во времени в миллисекундах
    const timeLeft = endOfDay.getTime() - now.getTime();
    
    // Переводим миллисекунды в часы, минуты и секунды
    const hours = Math.floor(timeLeft / (1000 * 60 * 60));
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
    
    // Форматируем время в HH:MM:SS
    const formattedTime = [
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
        seconds.toString().padStart(2, '0')
    ].join(':');
    
    // Обновляем содержимое таймера
    timerElement.textContent = formattedTime;
}
